(() => {
  const animateSlideContent = (slide) => {
    if (!slide) return;
    const contentWrapper = slide.querySelector(
      ".slideshow__content-wrapper-type-2"
    );
    if (!contentWrapper) return;
    contentWrapper.setAttribute("data-content-animation", "true");
  };
  const initSlider = (section) => {
    const box = section.querySelector(".slideshow-wrapper");
    if (box) {
      const swiperParams = {
        allowTouchMove: false,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,
        effect: "slide",
        speed: 0,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: ".slideshow-nav-button-type-2--next",
          prevEl: ".slideshow-nav-button-type-2--prev",
        },
      };
      if (box.getAttribute("data-autoplay") === "true") {
        swiperParams.autoplay = {
          disableOnInteraction: true,
        };
      }
      if (box.getAttribute("data-loop") === "true") {
        swiperParams.loop = true;
        swiperParams.loopPreventsSliding = false;
      }
      const slider = box.querySelector(".slideshow__swiper-type-2");
      const slideshowSwiper = new Swiper(slider, {
        ...swiperParams,
      });
      if (box.dataset.animationInit == "true") {
        slideshowSwiper.on("slideChangeTransitionStart", (swiper) => {
          swiper.slides.forEach((slide) => {
            const contentWrapper = slide.querySelector(
              ".slideshow__content-wrapper-type-2"
            );
            if (!contentWrapper) return;
            contentWrapper.setAttribute("data-content-animation", "false");
          });
          animateSlideContent(swiper.slides[swiper.activeIndex]);
        });
      }
    }
  };
  initSlider(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", function (event) {
    initSlider(event.target);
  });
})();
